import React from 'react'
import "../css file/seventhsection.css"
function SeventhSection() {
    return (
        <>
            <div className="seventh-section-container">
                <div className="seventh-section-container-main-card-section">
                    <div className="seventh-section-container-main-card">
                        <div className="seventh-section-container-main-img">
                            <img className="seventh-section-container-main-box-img" src="https://www.tourism.gov.np//images/general_contact_images/11.jpg" alt="" />
                        </div>
                        <div className="seventh-section-container-main-content">
                            <p className="seventh-section-container-main-content-p">
                            सह-प्रवक्ता
                            </p>
                            <p className="seventh-section-container-main-content-p1">
                            श्री प्रेम सुवेदी
                            </p>
                            <p className="seventh-section-container-main-content-p2">
                            उपसचिव/सूचना अधिकारी
                            </p>
                            <p className="seventh-section-container-main-content-p2">
                                Tel.: 9851313022
                            </p>
                            <div className="seventh-section-container-main-content-main-icon">
                                <div className="seventh-section-container-facebook-img">
                                    <img className="seventh-section-container-facebook-img-main" src="https://www.tourism.gov.np/web/img/tw.svg" alt="" />
                                </div>
                                <div className="seventh-section-container-twitter-img">
                                    <img className="seventh-section-container-twitter-img-main" src="https://www.tourism.gov.np/web/img/fb.svg" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="seventh-section-container-main-card-section">
                    <div className="seventh-section-container-main-card">
                        <div className="seventh-section-container-main-img">
                            <img className="seventh-section-container-main-box-img" src="https://www.tourism.gov.np//images/general_contact_images/12.jpg" alt="" />
                        </div>
                        <div className="seventh-section-container-main-content">
                            <p className="seventh-section-container-main-content-p">
                            उत्कृष्ट कर्मचारी २०७७
                            </p>
                            <p className="seventh-section-container-main-content-p1">
                            प्रल्हाद प्रसाद पुडासैनी
                            </p>
                            <p className="seventh-section-container-main-content-p2">
                            उपसचिव
                            </p>
                            <p className="seventh-section-container-main-content-p2">
                                Tel.: ९८४१४०५४७५
                            </p>
                            <div className="seventh-section-container-main-content-main-icon">
                                <div className="seventh-section-container-facebook-img">
                                    <img className="seventh-section-container-facebook-img-main" src="https://www.tourism.gov.np/web/img/tw.svg" alt="" />
                                </div>
                                <div className="seventh-section-container-twitter-img">
                                    <img className="seventh-section-container-twitter-img-main" src="https://www.tourism.gov.np/web/img/fb.svg" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="seventh-section-container-main-card-section">
                    <div className="seventh-section-container-main-card">
                        <div className="seventh-section-container-main-img">
                            <img className="seventh-section-container-main-box-img" src="https://www.tourism.gov.np//images/general_contact_images/13.jpg" alt="" />
                        </div>
                        <div className="seventh-section-container-main-content">
                            <p className="seventh-section-container-main-content-p">
                            उत्कृष्ट कर्मचारी २०७७
                            </p>
                            <p className="seventh-section-container-main-content-p1">
                            होमनाथ काफ्ले
                            </p>
                            <p className="seventh-section-container-main-content-p2">
                                शाखा अधिकृत
                            </p>
                            <p className="seventh-section-container-main-content-p2">
                                Tel.: ९८४३४८८२७५
                            </p>
                            <div className="seventh-section-container-main-content-main-icon">
                                <div className="seventh-section-container-facebook-img">
                                    <img className="seventh-section-container-facebook-img-main" src="https://www.tourism.gov.np/web/img/tw.svg" alt="" />
                                </div>
                                <div className="seventh-section-container-twitter-img">
                                    <img className="seventh-section-container-twitter-img-main" src="https://www.tourism.gov.np/web/img/fb.svg" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="seventh-section-container-main-card-section seventh-section-container-main-card-grid">
                    <div className="seventh-section-container-main-card border">
                        <div className="seventh-section-container-main-img">
                            <img className="seventh-section-container-main-box-img" src="https://www.tourism.gov.np//images/general_contact_images/14.jpg" alt="" />
                        </div>
                        <div className="seventh-section-container-main-content">
                            <p className="seventh-section-container-main-content-p">
                                उत्कृष्ट कर्मचारी २०७७
                            </p>
                            <p className="seventh-section-container-main-content-p1">
                            सञ्च ब तामाङ
                            </p>
                            <p className="seventh-section-container-main-content-p2">
                            कार्यालय सहयोगी
                            </p>
                            <p className="seventh-section-container-main-content-p2">
                                Tel.: ९८०८६४७२८३
                            </p>
                            <div className="seventh-section-container-main-content-main-icon">
                                <div className="seventh-section-container-facebook-img">
                                    <img className="seventh-section-container-facebook-img-main" src="https://www.tourism.gov.np/web/img/tw.svg" alt="" />
                                </div>
                                <div className="seventh-section-container-twitter-img">
                                    <img className="seventh-section-container-twitter-img-main" src="https://www.tourism.gov.np/web/img/fb.svg" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default SeventhSection
